export const AUTHORIZATION_LOGIN_SUCCESS = 'AUTHORIZATION_LOGIN_SUCCESS';
export const AUTHORIZATION_LOGOUT = 'AUTHORIZATION_LOGOUT';

export const PERSON_LOAD = 'PERSON_LOAD';
export const PERSON_LOAD_SUCCESS = 'PERSON_LOAD_SUCCESS';